import React, { useEffect, useRef, useState } from "react";
import { json, Link, useLocation, useNavigate } from "react-router-dom";
import { InnModalPopup } from "../innModalPopup";
import calenderIcon from "../../assets/images/top-calender-icon.svg";
import buldingIcon from "../../assets/images/top-building-icon.svg";
import backArrowIcon from "../../assets/images/top-back-arrow.svg";
import moment from "moment";
import InnRadioButton from "../innRadiobutton";
import { InnTextbox } from "../innTextbox";
import { InnSingleSelectDropdown } from "../innDropdown";
import { InnFileUpload } from "..";
import { useDispatch, useSelector } from "react-redux";
import {
    GetCityListfromCountry,
    GetCountryList,
    GetIdentificationForSelfCheckinapp,
    GetNationality,
    GetRoomGuestData,
    InsertGuestDetailSingle,
    ValidateMediaFunction
} from "../../services/selfCheckinService";
import {
    clearAllData,
    currentUser,
    encodedStringData,
    propertyDetails,
    reservationData,
    setBackPagePhoto,
    setDocumentType,
    setFrontPagePhoto,
    setHomeNavigate,
    setImmigrationImage,
    setVisaStampImage
} from "../../reducer/selfCheckinSlice";
import { InnLoader } from "../innLoader";
import Preview from "./Preview";

function Registration(props) {
    const rTravelData = [
        { key: "Air", value: "Air" },
        { key: "Rail", value: "Rail" },
        { key: "Road", value: "Road" },
    ];
    const rData = [
        { key: "Yes", value: "Yes" },
        { key: "No", value: "No" },
    ];

    //#region State Variable
    const [showCalenderData, setShowCalenderData] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [guestDetail, setGuestDetail] = useState([]);
    const [filterGuestDetail, setFilterGuestDetail] = useState({});
    const [roomCategory, setRoomCategory] = useState([]);
    const [nationalityCombo, setNationalityCombo] = useState([]);
    const [selectedNationality, setSelectedNationality] = useState({});
    const [countryCodeCombo, setCountryCodeCombo] = useState([]);
    const [selectedCountryCode, setSelectedCountryCode] = useState();
    const [selectedCountryID, setSelectedCountryID] = useState();
    const [countryCombo, setCountryCombo] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState({});
    const [selectedCountryforCity, setSelectedCountryforCity] = useState({})
    const [cityList, setCityList] = useState([]);
    const [selectedCity, setSelectedCity] = useState();
    const [idTypeCombo, setIDTypeCombo] = useState([]);
    const [idTypeName, setIDTypeName] = useState();
    const [selectedIDTypeCombo, setSelectedIDTypeCombo] = useState({});
    const [frontPageImage, setfrontPageImage] = useState();
    const [oldFrontPageImage, setOldFrontPageImage] = useState();
    const [backPageIamge, setBackPageImage] = useState();
    const [oldBackPageImage, setOldBackPageImage] = useState();
    const [visaStamp, setVisaStamp] = useState();
    const [oldVisaStamp, setOldVisaStamp] = useState();
    const [immigrationStamp, setImmigrationStamp] = useState()
    const [oldImmigrationStamp, setOldImmigrationStamp] = useState()
    const [bookingSerNo, setBookingSerNo] = useState([]);
    const [selectedCovid, setSelectedCovid] = useState();
    const [isTravelledOutside, setIsTravelledOutside] = useState();
    const [guestName, setGuestName] = useState();
    const [guestMobileNo, setGuestMobileNo] = useState();
    const [guestEmail, setGuestEmail] = useState();
    const [travelledArea, setTravelledArea] = useState();
    const [isFamilyHasSymptoms, setIsFamilyHasSymptoms] = useState(false);
    const [travelleFrom, setSelectedTravelleFrom] = useState();
    const [travelFromVia, setTravelFromVia] = useState();
    const [travellFromDetail, setTravellFromDetail] = useState();
    const [travellTo, setTravellTo] = useState();
    const [travellToVia, setTravellToVia] = useState();
    const [travelToDetail, setTravelToDetail] = useState();
    const [defaultSerNo, setDefaultSerNo] = useState({});
    const [noOfGuest, setNoOfGuest] = useState([]);
    const [validationObj, setValidationObj] = useState({
        GuestName: "",
        CountryCode: "",
        Nationality: "",
        FrontImage: "",
        BackImage: "",
        IsSelectedCovidOptn: "",
        IsSelectedTravelledOutside: "",
        IsSelectedFamilySymptomsOptn: "",
        Country: "",
        City: "",
        Area: "",
        IDType: ""
    })
    const [roomGuestData, setRoomGuestData] = useState({});
    const [seqData, setSeqData] = useState([]);
    const [currentSeqNo, setCurrentSeqNo] = useState();
    const [currentGuestIndex, setCurrentGuestIndex] = useState(0);
    const [currentResIndex, setCurrentResIndex] = useState(0);
    const [previewPopup, setPreviewPopup] = useState(false);
    const [guestObj, setGuestObj] = useState({});
    const [selectedCountryForISDCode, setSelectedCountryForISDCode] = useState();

    const [frontLoading, setFrontLoading] = useState(false);
    const [backLoading, setBackLoading] = useState(false);
    const [visaLoading, setVisaLoading] = useState(false);
    const [immigrationLoading, setImmigrationLoading] = useState(false);

    const [frontType, setFrontType] = useState("");
    const [backType, setBackType] = useState("");
    const [visaType, setVisaType] = useState("");
    const [immigrationType, setImmigrationType] = useState("");
    
    //Preview Path 
    const [frontPreviewPath, setFrontPreviewPath] = useState("");
    const [backPreviewPath, setBackPreviewPath] =  useState("");
    const [visaPreviewPath, setVisaPreviewPath] =  useState("");
    const [immigrationPreviewPath, setImmigrationPreviewPath] = useState("");

    const [oldfrontPreviewPath, setOldFrontPreviewPath] = useState("");
    const [oldbackPreviewPath, setOldBackPreviewPath] =  useState("");
    const [oldvisaPreviewPath, setOldVisaPreviewPath] =  useState("");
    const [oldimmigrationPreviewPath, setOldImmigrationPreviewPath] = useState("");

    //#endregion

    //#region Local Variable
    const guestDetailObj = useSelector(reservationData);
    const navigate = useNavigate();
    const encodeStringObj = useSelector(encodedStringData)
    const propertyDetailObj = useSelector(propertyDetails);
    let currUser = useSelector(currentUser);
    let ClientID = currUser?.ClientID;
    let PropertyID = currUser?.PropertyID;
    let BookingNo = currUser?.BookingNo;
    const dispatch = useDispatch();
    const wait = timeOut => {
        return new Promise(resolve => setTimeout(resolve, timeOut));
    }
    //#endregion

    //#region Service Call
    const fillGuestDetails = () => {
        setIsActive(true);
        GetRoomGuestData(ClientID, PropertyID, BookingNo).then((d) => {
            setRoomGuestData(d.data);
            wait(1000).then(() => setIsActive(false))
            let tempData = d.data?.reservationDetailsub;
            if (tempData.length > 0) {
                setCurrentSeqNo(tempData[0]?.SequenceNo)
            }
            let isRoomCatgColor = false;
            let obj = [];
            tempData.forEach((x) => {
                x["isRoomCatgColor"] = isRoomCatgColor;
                obj.push(x.BookingSer_No);
                x.guestDetails.forEach((y) => {
                    y.IsGuestRegister = false
                    if (y.GuestName == null) {
                        y.GuestName = "";
                    }
                    if (y.ISDCode == null) {
                        y.ISDCode = ""
                    }
                    if (y.GuestMobile == null) {
                        y.GuestMobile = ""
                    }
                    if (y.GuestEmail == null) {
                        y.GuestEmail = ""
                    }
                    if (y.Nationality_ID == null) {
                        y.Nationality_ID = ""
                    }
                    if (y.IsTravelledOutside == null) {
                        y.IsTravelledOutside = ""
                    }
                    if (y.HasCoronaSymptoms == null) {
                        y.HasCoronaSymptoms = ""
                    }
                    if (y.IsFamilyHasSymptoms == null) {
                        y.IsFamilyHasSymptoms = ""
                    }
                    if (y.TravelledCountry == null) {
                        y.TravelledCountry = ""
                    }
                    if (y.TravelledCity == null) {
                        y.TravelledCity = ""
                    }
                    if (y.TravelledArea == null) {
                        y.TravelledArea = ""
                    }
                    if (y.IDType == null) {
                        y.IDType = ""
                    }
                })
            });

            tempData.map((x, ind) => {
                if (ind == 0) {
                    x.isRoomCatgColor = true
                } else {
                    x.isRoomCatgColor = false
                }
            });
            setRoomCategory(tempData);
            setGuestDetail(tempData)

            setFilterGuestDetail(d.data?.guestdetaildata[0]);
            let tempObj = tempData[0]?.guestDetails
            tempObj.forEach((x) => {
                x["isGuestCheckInColor"] = false;
            });
            let noOfGuests = [];
            let tempGuest = [];
            for (let index = 0; index < tempObj.length; index++) {
                noOfGuests.push(index + 1);
                tempGuest.push(tempObj[index]);
            }
            setNoOfGuest(tempGuest);


            // if (state?.state != undefined && state?.state != null) {
            //     if (state.state.path == "Preview") {
            //         setSelectedCountry(tempObj[0].TravelledCountry)
            //         setTravelledArea(tempObj[0].TravelledArea);
            //         setIsFamilyHasSymptoms(tempObj[0].IsFamilyHasSymptoms ? "Yes" : "No");
            //         if (filterGuestDetail != undefined) {
            //             setGuestName(tempObj[0].GuestName);
            //         } else {
            //             setGuestName(guestDetailObj?.GuestName);
            //         }
            //         setGuestMobileNo(tempObj[0].GuestMobile)
            //         setGuestEmail(tempObj[0].GuestEmail)
            //         setTravelFromVia(tempObj[0].TravelFromVia)
            //         setTravelToDetail(tempObj[0].TravelToDetail)
            //         setTravellFromDetail(tempObj[0].TravelFromDetail);
            //         setSelectedTravelleFrom(tempObj[0].TravelFrom);
            //         setTravellToVia(tempObj[0].TravelToVia);
            //         setTravellTo(tempObj[0].TravelTo);
            //         setSelectedCountryforCity({ "key": "Sel", "value": "Select Country" })
            //         setSelectedNationality(tempObj[0].Nationality_ID);
            //         let tempIDType = tempObj[0].IDType === undefined ? idTypeCombo[0]?.key : tempObj[0].IDType;
            //         setSelectedIDTypeCombo(tempIDType)
            //         setSelectedCovid(tempObj[0].HasCoronaSymptoms ? "Yes" : "No");
            //         setIsTravelledOutside(tempObj[0].IsTravelledOutside ? "Yes" : "No");
            //         setfrontPageImage(tempObj[0].Image_PathData.fileAsBase64)
            //         setOldFrontPageImage(tempObj[0].Image_PathData.fileAsBase64)
            //         setOldBackPageImage(tempObj[0].Image_Path_BackData.fileAsBase64);
            //         setBackPageImage(tempObj[0].Image_Path_BackData.fileAsBase64);
            //         setVisaStamp(tempObj[0].VisaStamp);
            //         setOldVisaStamp(tempObj[0].VisaImageData?.fileAsBase64)
            //         setImmigrationStamp(tempObj[0].ImmigrationStamp)
            //         setOldImmigrationStamp(tempObj[0].ImmigrationImageData?.fileAsBase64)
            //         setSelectedCountryCode(tempObj[0].ISDCode);
            //         setSelectedCity(tempObj[0].TravelledCity);
            //         setGuestObj(tempObj[0]);
            //         console.log("serno", tempObj.Ser_No)
            //     }
            // }
            // else {
            setSelectedCountry(tempObj[0]?.TravelledCountry)
            setTravelledArea(tempObj[0]?.TravelledArea);
            setIsFamilyHasSymptoms(tempObj[0]?.IsFamilyHasSymptoms ? "Yes" : "No");
            if (filterGuestDetail != undefined) {
                setGuestName(tempObj[0]?.GuestName);
            } else {
                setGuestName(guestDetailObj?.GuestName);
            }
            setGuestMobileNo(tempObj[0]?.GuestMobile)
            setGuestEmail(tempObj[0]?.GuestEmail)
            setTravelFromVia(tempObj[0]?.TravelFromVia)
            setTravelToDetail(tempObj[0]?.TravelToDetail)
            setTravellFromDetail(tempObj[0]?.TravelFromDetail);
            setSelectedTravelleFrom(tempObj[0]?.TravelFrom);
            setTravellToVia(tempObj[0]?.TravelToVia);
            setTravellTo(tempObj[0]?.TravelTo);
            setSelectedCountryforCity({ "key": "Sel", "value": "Select Country" })
            setSelectedNationality(tempObj[0]?.Nationality_ID);
            let tempIDType = tempObj[0]?.IDType === undefined ? idTypeCombo[0]?.key : tempObj[0]?.IDType;
            setSelectedIDTypeCombo(tempIDType)
            setSelectedCovid(tempObj[0]?.HasCoronaSymptoms ? "Yes" : "No");
            setIsTravelledOutside(tempObj[0]?.IsTravelledOutside ? "Yes" : "No");
            setfrontPageImage(tempObj[0]?.Image_PathData?.fileAsBase64)
            setOldFrontPageImage(tempObj[0]?.Image_PathData?.fileAsBase64)
            setOldBackPageImage(tempObj[0]?.Image_Path_BackData?.fileAsBase64);
            setBackPageImage(tempObj[0]?.Image_Path_BackData?.fileAsBase64);
            setVisaStamp(tempObj[0]?.VisaImageData?.fileAsBase64);
            setOldVisaStamp(tempObj[0]?.VisaImageData?.fileAsBase64)
            setImmigrationStamp(tempObj[0]?.ImmigrationImageData?.fileAsBase64)
            setOldImmigrationStamp(tempObj[0]?.ImmigrationImageData?.fileAsBase64)
            //console.log("empObj[0]?.ISDCode", tempObj[0]?.ISDCode)
            setSelectedCountryCode(tempObj[0]?.ISDCode);
            setSelectedCountryID(tempObj[0]?.Country_ID);
            setSelectedCountryForISDCode(tempObj[0]?.Country_ID);
            setSelectedCity(tempObj[0]?.TravelledCity);
            setFrontPreviewPath(tempObj[0]?.FrontSide);
            setBackPreviewPath(tempObj[0]?.BackSide);
            setVisaPreviewPath(tempObj[0]?.VisaStamp);
            setImmigrationPreviewPath(tempObj[0]?.ImmigrationStamp);

            setOldFrontPreviewPath(tempObj[0]?.FrontSide);
            setOldBackPreviewPath(tempObj[0]?.BackSide);
            setOldVisaPreviewPath(tempObj[0]?.VisaStamp);
            setOldImmigrationPreviewPath(tempObj[0]?.ImmigrationStamp);
            setGuestObj(tempObj[0]);
            // }
        }).catch((err) => {
            console.log(err);
            wait(1000).then(() => setIsActive(false))
        });
    }
    const fillNationalityCombo = () => {
        setIsActive(true);
        GetNationality(ClientID).then((d) => {
            wait(1000).then(() => setIsActive(false))
            let temp = d.data
            temp.shift()
            // console.log("Nationality Data from api :: ", temp)
            let tempData = [{ "key": "Sel", "value": "Select" }];
            temp.forEach(x => {
                tempData.push({ "key": x.Nationality_ID, "value": x.Name, "CountryID": x.Country_ID })
            });
            setNationalityCombo(tempData);
        }).catch((err) => {
            wait(1000).then(() => setIsActive(false))
            console.log(err);
        });
    }
    const fillCountryCode = () => {
        setIsActive(true);
        GetCountryList(ClientID).then((d) => {
            wait(1000).then(() => setIsActive(false))
            let temp = d.data;
            temp.shift()
            let tempData = [{ "key": "Sel", "value": "Select Code" }];
            let tempCountry = [{ "key": "Sel", "value": "Select Country" }];
            // console.log("Country Code data ::", temp)
            temp.forEach((x) => {
                tempData.push({ "key": x.Country_ID, "value": '+' + x.ISDCode, "Code": x.ALPHA_CODE_3, CountryID: x.Country_ID })
                tempCountry.push({ "key": x.Country_ID, "value": x.Name })

            })
            setCountryCodeCombo(tempData)
            setCountryCombo(tempCountry)
        }).catch((err) => {
            wait(1000).then(() => setIsActive(false))
            console.log(err);
        });
    }
    const fillCityListFromCountry = (CountryID) => {
        setIsActive(true);
        GetCityListfromCountry(ClientID, CountryID).then((d) => {
            wait(1000).then(() => setIsActive(false))
            let obj = d.data;
            let temp = [{ "key": "Sel", "value": "Select City" }];
            obj.forEach((x) => {
                temp.push({ 'key': x.Country_ID, 'value': x.City_Name });
            });
            setCityList(temp);
        })
    }
    const fillIDTypeCombo = () => {
        GetIdentificationForSelfCheckinapp(ClientID).then((d) => {
            let obj = d.data;
            let tempData = [];
            obj.forEach((x) => {
                tempData.push({ 'key': x.IDType, 'value': x.Name });
            });
            let sortCombo = tempData.sort(function (a, b) {
                return (
                    a.value > b.value ? 1 : (a.value === b.value ? 0 : -1)
                )
            });
            setIDTypeCombo(sortCombo);
        }).catch((err) => {
            console.log(err);
        });
    }
    //#endregion

    //#region Input Validation
    const validate = () => {
        // if (!Boolean(guestName)) {
        //     setValidationObj((prev) => ({ ...prev, GuestName: "Please enter valid name." }))
        // }
        const namePattern = /^[A-Za-z ]+$/;  // Only allows alphabets (both upper and lower case)

        if (!Boolean(guestName) || !Boolean(guestName?.trim().length)) {
            setValidationObj((prev) => ({ ...prev, GuestName: "Please enter a valid name." }));
        } else if (!namePattern.test(guestName)) {
            setValidationObj((prev) => ({ ...prev, GuestName: "Name cannot contain numbers or special characters." }));
        }
        if (!Boolean(selectedNationality)) {
            setValidationObj((prev) => ({ ...prev, Nationality: "Please enter valid nationality." }));
        }
        if (!Boolean(selectedCountryCode) || selectedCountryCode == "Select") {
            setValidationObj((prev) => ({ ...prev, CountryCode: "Please enter valid country code." }));
        }
        if (!Boolean(frontPageImage)) {
            setValidationObj((prev) => ({ ...prev, FrontImage: "Please upload an image." }))
        }
        if (!Boolean(backPageIamge)) {
            setValidationObj((prev) => ({ ...prev, BackImage: "Please upload an image." }))
        }
        if (!Boolean(isTravelledOutside)) {
            setValidationObj((prev) => ({ ...prev, IsSelectedTravelledOutside: "Please select valid input." }))
        }
        if (!Boolean(isFamilyHasSymptoms)) {
            setValidationObj((prev) => ({ ...prev, IsSelectedFamilySymptomsOptn: "Please select valid input." }))
        }
        if (!Boolean(selectedCovid)) {
            setValidationObj((prev) => ({ ...prev, IsSelectedCovidOptn: "Please select valid input." }))
        }
        if (!Boolean(isTravelledOutside)) {
            if (!Boolean(selectedCountry) || selectedCountry == "Sel") {
                setValidationObj((prev) => ({ ...prev, Country: "Please select valid country." }))
            }
            if (!Boolean(selectedCity)) {
                setValidationObj((prev) => ({ ...prev, City: "Please select valid city." }))
            }
            if (!Boolean(travelledArea)) {
                setValidationObj((prev) => ({ ...prev, Area: "Please enter valid area." }))
            }
        }
        if (!Boolean(selectedIDTypeCombo)) {
            setValidationObj((prev) => ({ ...prev, IDType: "Please select valid input." }))
        }
    }

    //#region OnClick Proceed Button
    const onClickProceedButton = (index) => {
        const namePattern = /^[A-Za-z ]+$/;  // Only allows alphabets (both upper and lower case)
        if (!Boolean(guestName) || !Boolean(guestName?.trim().length)) {
            return
        } else if (!namePattern.test(guestName)) {
            return
        }
        if (!Boolean(selectedNationality) || selectedNationality == "Sel") {
            // console.log("selectedNationality", selectedNationality)
            return
        }
        if (!Boolean(selectedCountryCode) || selectedCountryCode == "Select") {
            // console.log("selectedCountryCode", selectedCountryCode)
            return
        }
        if (!Boolean(frontPageImage)) {
            // console.log("frontPageImage", frontPageImage)
            return
        }
        if (!Boolean(backPageIamge)) {
            // console.log("backPageIamge", backPageIamge)
            return
        }
        if (!Boolean(isTravelledOutside)) {
            // console.log("isTravelledOutside", isTravelledOutside)
            return
        }
        if (!Boolean(isFamilyHasSymptoms)) {
            // console.log("isFamilyHasSymptoms", isFamilyHasSymptoms)
            return
        }
        if (!Boolean(selectedCovid)) {
            // console.log("selectedCovid", selectedCovid)
            return
        }
        if (!Boolean(isTravelledOutside)) {
            if (!Boolean(selectedCountry) || selectedCountry == "Sel") {
                // console.log("selectedCountry", selectedCountry)
                return
            }
            if (!Boolean(selectedCity)) {
                // console.log("selectedCity", selectedCity)
                return
            }
            if (!Boolean(travelledArea)) {
                // console.log("travelledArea", travelledArea)
                return
            }
        }
        if (!Boolean(selectedIDTypeCombo)) {
            // console.log("idtype", selectedIDTypeCombo)
            return
        }
        else {
            if (selectedNationality != "INDIA" && !Boolean(visaStamp)) {
                // console.log("visaStamp", visaStamp)
                return
            }
            if (selectedNationality != "INDIA" && !Boolean(immigrationStamp)) {
                // console.log("immigrationStamp", immigrationStamp)
                return
            }
            else {
                InsertSingleGuestDetail();
            }
        }
    }
    //#endregion

    function trimPlus(str) {
        if (typeof str !== "string") return str; // guard for non-strings
        return str.startsWith("+") ? str.slice(1) : str;
    }
    //#region Insert Single Guest Detail
    const InsertSingleGuestDetail = () => {
        let para = {
            Client_ID: ClientID,
            Property_ID: PropertyID,
            // Booking_No: filterGuestDetail?.Booking_No == undefined ? guestDetailObj?.Booking_No : filterGuestDetail?.Booking_No,
            Booking_No: guestObj?.Booking_No == undefined ? guestDetailObj?.Booking_No : guestObj?.Booking_No,
            // BookingSubSer_No: filterGuestDetail?.BookingSubSer_No == undefined ? defaultSerNo?.BookingSubSer_No : filterGuestDetail?.BookingSubSer_No,
            BookingSubSer_No: guestObj?.BookingSubSer_No == undefined ? defaultSerNo?.BookingSubSer_No : guestObj?.BookingSubSer_No,
            // BookingSer_No: filterGuestDetail?.BookingSer_No == undefined ? defaultSerNo?.BookingSer_No : filterGuestDetail?.BookingSer_No,
            BookingSer_No: guestObj?.BookingSer_No == undefined ? defaultSerNo?.BookingSer_No : guestObj?.BookingSer_No,
            Ser_No: guestObj?.Ser_No,
            // Ser_No: filterGuestDetail?.Ser_No,
            GuestName: guestName,
            GuestMobile: guestMobileNo,
            GuestEmail: guestEmail,
            Nationality_ID: selectedNationality,
            IDType: selectedIDTypeCombo === "" ? null : selectedIDTypeCombo,
            //FrontSide: frontPageImage === undefined ? frontPageImage : frontPageImage,
            FrontSide: frontPreviewPath,
            Image_PathData:
            {
                fileAsBase64: frontPageImage === undefined ? oldFrontPageImage : frontPageImage,
                fileName: frontPageImage?.fname === undefined ? "" : frontPageImage?.fname,
                fileSize: 200,
                fileType: frontType,
            },
            //BackSide: backPageIamge === undefined ? backPageIamge : backPageIamge,
            BackSide: backPreviewPath,
            Image_Path_BackData:
            {
                FileAsByteArray: null,
                fileAsBase64: backPageIamge === undefined ? oldBackPageImage : backPageIamge,
                fileName: backPageIamge?.fname === undefined ? "" : backPageIamge?.fname,
                fileSize: 200,
                fileType: backType,
            },
            //VisaStamp: visaStamp === undefined ? visaStamp : visaStamp,
            VisaStamp: visaPreviewPath,
            VisaImageData:
            {
                FileAsByteArray: null,
                fileAsBase64: visaStamp === undefined ? oldVisaStamp : visaStamp,
                fileName: visaStamp,
                fileSize: 200,
                fileType: visaType,
            },
            //ImmigrationStamp: immigrationStamp === undefined ? immigrationStamp : immigrationStamp,
            ImmigrationStamp: immigrationPreviewPath,
            ImmigrationImageData:
            {
                FileAsByteArray: null,
                fileAsBase64: immigrationStamp === undefined ? oldImmigrationStamp : immigrationStamp,
                fileName: immigrationStamp,
                fileSize: 200,
                fileType: immigrationType,
            },
            IsTravelledOutside: isTravelledOutside == "Yes" ? true : false,
            TravelledCountry: selectedCountry === undefined || selectedCountry == "Select Country" ? "" : selectedCountry,
            TravelledCity: selectedCity === "Yes" ? 1 : selectedCity === "" ? 0 : 0,
            TravelledArea: travelledArea === '' || undefined ? "" : travelledArea,
            HasCoronaSymptoms: selectedCovid === "Yes" ? true : false,
            IsFamilyHasSymptoms: isFamilyHasSymptoms === "Yes" ? true : false,
            ISDCode: trimPlus(selectedCountryCode),
            TravelFrom: travelleFrom,
            TravelFromVia: travelFromVia,
            TravelFromDetail: travellFromDetail,
            TravelTo: travellTo,
            TravelToVia: travellToVia,
            TravelToDetail: travelToDetail,
            Country_ID: selectedCountryID
        }
        setIsActive(true);
        InsertGuestDetailSingle(para).then((d) => {
            wait(1000).then(() => setIsActive(false))
            // console.log("Return value :: ", d.data)

            if (d.data === false) {
                alert("Please verify mandotory field.");
            }
            else {
                guestFocusShiftFunc();
            }
        }).catch((ex) => {
            wait(1000).then(() => setIsActive(false))
            navigate("/Registration")
        });
    }


    const ValidateMediaFunctionUpload = async (Sourcekey, base64String, fileType, WhichFileUpload, InsertPath) => {
        let para = {
            ClientID: ClientID,
            sourceKey: Sourcekey,
            Base64String: base64String,
            FileType: fileType 
        };
        try {
            const d = await ValidateMediaFunction(para);
            let body = d.data?.body;
            if (typeof body === "string") {
                body = JSON.parse(body);
            }

            if (body?.statusCode === 200) {
                if(WhichFileUpload == 'Front'){
                    setfrontPageImage(base64String);
                    setFrontPreviewPath(InsertPath);
                    setFrontType(fileType);
                }
                else if(WhichFileUpload == 'Back'){
                    setBackPageImage(base64String);
                    setBackPreviewPath(InsertPath);
                    setBackType(fileType);
                }
                else if(WhichFileUpload == 'Visa'){
                    setVisaStamp(base64String);
                    setVisaPreviewPath(InsertPath);
                    setVisaType(fileType);
                }
                else if(WhichFileUpload == 'Immigration'){
                    setImmigrationStamp(base64String);
                    setImmigrationPreviewPath(InsertPath)
                    setImmigrationType(fileType);
                }
            } else {
                let response = body?.body;
                if (response) {
                    if (typeof response === "string") {
                        response = JSON.parse(response);
                    }
                    
                    if (WhichFileUpload == 'Front') {
                        setfrontPageImage(oldFrontPageImage);
                         setFrontPreviewPath(oldfrontPreviewPath);
                        setFrontType(fileType);
                    }
                    else if (WhichFileUpload == 'Back') {
                        setBackPageImage(oldBackPageImage);
                        setBackPreviewPath(oldbackPreviewPath);
                        setBackType(fileType);
                    }
                    else if (WhichFileUpload == 'Visa') {
                        setVisaStamp(oldVisaStamp);
                        setVisaPreviewPath(oldvisaPreviewPath);
                        setVisaType(fileType);
                    }
                    else if (WhichFileUpload == 'Immigration') {
                        setImmigrationStamp(oldImmigrationStamp);
                        setImmigrationPreviewPath(oldimmigrationPreviewPath)
                        setImmigrationType(fileType);
                    }

                    alert(response?.message);

                } else {
                    alert(body);
                }

            }
        } catch (ex) {
            console.log("Exeption", ex)
        }
    };

    const guestFocusShiftFunc = () => {
        let arr = guestDetail;
        arr.forEach((x, index) => {
            if (index == currentResIndex) {
                x.guestDetails.forEach((y, ind) => {
                    if (ind == currentGuestIndex) {
                        y.IsGuestRegister = true;
                    }
                })
            }
        })
        setGuestDetail(JSON.parse(JSON.stringify(arr)))
        let tempResIndex = roomGuestData.reservationDetailsub.length;
        let tempGuestIndex;
        if (tempResIndex > 0) {
            // if (currentResIndex < tempResIndex - 1) {

            tempGuestIndex = roomGuestData.reservationDetailsub[currentResIndex].guestDetails.length;
            if (currentGuestIndex + 1 <= tempGuestIndex - 1) {

                let tempObj = roomGuestData.reservationDetailsub[currentResIndex].guestDetails[currentGuestIndex + 1];

                setSelectedCountry(tempObj.TravelledCountry)
                setTravelledArea(tempObj.TravelledArea);
                setIsFamilyHasSymptoms(tempObj.IsFamilyHasSymptoms ? "Yes" : "No");
                setGuestName(tempObj.GuestName);
                setGuestMobileNo(tempObj.GuestMobile)
                setGuestEmail(tempObj.GuestEmail)
                setTravelFromVia(tempObj.TravelFromVia)
                setTravelToDetail(tempObj.TravelToDetail)
                setTravellFromDetail(tempObj.TravelFromDetail);
                setSelectedTravelleFrom(tempObj.TravelFrom);
                setTravellToVia(tempObj.TravelToVia);
                setTravellTo(tempObj.TravelTo);
                setSelectedCountryforCity({ "key": "Sel", "value": "Select Country" })
                setSelectedNationality(tempObj.Nationality_ID);
                let tempIDType = tempObj.IDType === "" ? idTypeCombo[0]?.key : tempObj.IDType;
                setSelectedIDTypeCombo(tempIDType)
                setSelectedCovid(tempObj.HasCoronaSymptoms ? "Yes" : "No");
                setIsTravelledOutside(tempObj.IsTravelledOutside ? "Yes" : "No");
                setfrontPageImage(tempObj.Image_PathData?.fileAsBase64)
                setOldFrontPageImage(tempObj.Image_PathData?.fileAsBase64)
                setOldBackPageImage(tempObj.Image_Path_BackData?.fileAsBase64);
                setBackPageImage(tempObj.Image_Path_BackData?.fileAsBase64);
                setVisaStamp(tempObj.VisaImageData?.fileAsBase64);
                setOldVisaStamp(tempObj.VisaImageData?.fileAsBase64)
                setImmigrationStamp(tempObj.ImmigrationImageData?.fileAsBase64)
                setOldImmigrationStamp(tempObj.ImmigrationImageData?.fileAsBase64)
                setSelectedCountryCode(tempObj.ISDCode);
                setSelectedCountryID(tempObj.Country_ID);
                setSelectedCountryForISDCode(tempObj.Country_ID);
                setSelectedCity(tempObj.TravelledCity);
                setGuestObj(tempObj);

                setCurrentGuestIndex((prev) => prev + 1);
            }
            else {
                if (currentResIndex + 1 < tempResIndex) {

                    setCurrentResIndex((prev) => prev + 1);
                    setCurrentGuestIndex(0);

                    let tempObj = roomGuestData.reservationDetailsub[currentResIndex + 1].guestDetails[0];

                    setCurrentSeqNo(roomGuestData.reservationDetailsub[currentResIndex + 1].SequenceNo)
                    setSelectedCountry(tempObj.TravelledCountry)
                    setTravelledArea(tempObj.TravelledArea);
                    setIsFamilyHasSymptoms(tempObj.IsFamilyHasSymptoms ? "Yes" : "No");
                    if (filterGuestDetail != undefined) {
                        setGuestName(tempObj.GuestName);
                    } else {
                        setGuestName(guestDetailObj?.GuestName);
                    }
                    setGuestMobileNo(tempObj.GuestMobile)
                    setGuestEmail(tempObj.GuestEmail)
                    setTravelFromVia(tempObj.TravelFromVia)
                    setTravelToDetail(tempObj.TravelToDetail)
                    setTravellFromDetail(tempObj.TravelFromDetail);
                    setSelectedTravelleFrom(tempObj.TravelFrom);
                    setTravellToVia(tempObj.TravelToVia);
                    setTravellTo(tempObj.TravelTo);
                    setSelectedCountryforCity({ "key": "Sel", "value": "Select Country" })
                    setSelectedNationality(tempObj.Nationality_ID);
                    let tempIDType = tempObj.IDType === "" ? idTypeCombo[0]?.key : tempObj.IDType;
                    setSelectedIDTypeCombo(tempIDType)
                    setSelectedCovid(tempObj.HasCoronaSymptoms ? "Yes" : "No");
                    setIsTravelledOutside(tempObj.IsTravelledOutside ? "Yes" : "No");
                    setfrontPageImage(tempObj.Image_PathData?.fileAsBase64)
                    setOldFrontPageImage(tempObj.Image_PathData?.fileAsBase64)
                    setOldBackPageImage(tempObj.Image_Path_BackData?.fileAsBase64);
                    setBackPageImage(tempObj.Image_Path_BackData?.fileAsBase64);
                    setVisaStamp(tempObj.VisaImageData?.fileAsBase64);
                    setOldVisaStamp(tempObj.VisaImageData?.fileAsBase64)
                    setImmigrationStamp(tempObj.ImmigrationImageData?.fileAsBase64)
                    setOldImmigrationStamp(tempObj.ImmigrationImageData?.fileAsBase64)
                    setSelectedCountryCode(tempObj.ISDCode);
                    setSelectedCountryID(tempObj.Country_ID);
                    setSelectedCountryForISDCode(tempObj.Country_ID);
                    setSelectedCity(tempObj.TravelledCity);
                    setGuestObj(tempObj);

                    let arr = roomCategory
                    arr.forEach((x, ind) => {

                        if (x.SequenceNo <= roomGuestData.reservationDetailsub[currentResIndex + 1].SequenceNo) {
                            x.isRoomCatgColor = true
                        }
                        else {
                            x.isRoomCatgColor = false
                        }
                    });
                    setRoomCategory(JSON.parse(JSON.stringify(arr)));
                }
                else {
                    navigate("/Registration1")
                }
            }
            // }
        }
    }

    //#endregion

    //#region UseEffect
    useEffect((e) => {
        setIsActive(true);
        fillGuestDetails();
        fillNationalityCombo();
        fillCountryCode();
        fillIDTypeCombo();
        wait(1000).then(() => setIsActive(false))
    }, []);

    useEffect(() => {
        if (selectedCountryforCity.key !== 'Sel' && selectedCountryforCity.key) {
            fillCityListFromCountry(selectedCountryforCity.key)
        } else if (selectedCountry) {
            fillCityListFromCountry(selectedCountry)
        }
        setDefaultSerNo(roomCategory[0]);
    }, [selectedCountryforCity, defaultSerNo])

    //#endregion
    return (
        <div>
            <InnLoader className={isActive ? "active" : null}></InnLoader>
            <div className="wrapper">
                <div className="top-blue-bg">
                    {/* <Link to="/HomePage"> */}
                    <div className="top-back-arrow">
                        <img src={backArrowIcon} onClick={() => {
                            navigate(`/HomePage/${encodeStringObj}`)
                        }} />
                    </div>
                    {/* </Link> */}
                    <div className="top-blue-hdng">
                        <h3>{filterGuestDetail?.GuestName == undefined ? guestDetailObj?.GuestName : filterGuestDetail?.GuestName}</h3>
                        <h5>Booking No: {guestDetailObj?.Booking_No}</h5>
                    </div>
                    <div className="top-blue-bg-icon">
                        <div>
                            <img
                                onClick={() => {
                                    setIsActive(true)
                                    setShowCalenderData(!showCalenderData)
                                    wait(1000).then(() => setIsActive(false))
                                }}
                                src={calenderIcon}
                            />
                        </div>

                        {/* <Link to="/HomeInfo"> */}
                        <div style={{ marginLeft: 10 }}>
                            <img src={buldingIcon} onClick={() => {
                                navigate("/HomeInfo")
                                dispatch(setHomeNavigate("FromRegistrationPage"));
                            }} />
                        </div>
                        {/* </Link> */}
                    </div>
                </div>
                <div className="top-light-bg">
                    {
                        roomCategory && roomCategory.map((x) => {
                            return (
                                x?.isRoomCatgColor === false ?
                                    <div className="top-room-box">
                                        <div className="top-room-type-active">
                                            <p>Room</p>
                                            <h5>{x?.RoomCatg_ID}</h5>
                                        </div>
                                        <div className="top-room-count">{x?.SequenceNo}</div>
                                    </div>
                                    :
                                    x.isRoomCatgColor === true ?
                                        <div className="top-room-box-active">
                                            <div className="top-room-type-active">
                                                <p>Room</p>
                                                <h5>{x?.RoomCatg_ID}</h5>
                                            </div>
                                            <div className="top-room-count">{x?.SequenceNo}</div>
                                        </div>
                                        :
                                        <></>
                            );
                        })
                    }
                    {/* <div className="top-room-box">
                        <div className="top-room-type-active">
                            <p>Room</p>
                            <h5>WG</h5>
                        </div>
                        <div className="top-room-count">2</div>
                    </div> */}
                </div>
                <div className="guest-opt">
                    <div className="guest-opt-gry-bdr"></div>
                    <div className="top-guest-opt">
                        {
                            guestDetail.map(d => {
                                return (
                                    d.SequenceNo == currentSeqNo ?
                                        d.guestDetails.map((x, index) => {
                                            return (
                                                // roomGuestData?.guestdetaildata.filter((d) => x.BookingSer_No == d.BookingSer_No && d.BookingSubSer_No == x.BookingSubSer_No && d.Ser_No == x.Ser_No).length > 0
                                                x.IsGuestRegister ?
                                                    <div>
                                                        <div className="guest-opt-gry-bg"></div>
                                                        <p>Guest {x.Ser_No}</p>  {/*SequenceNo */}
                                                    </div>
                                                    :
                                                    <div>
                                                        <div className="guest-opt-dark-bg"></div>
                                                        <p>Guest {x.Ser_No}</p>
                                                    </div>
                                            )
                                        })
                                        :
                                        <></>
                                )
                            })
                        }
                    </div>
                    <div className="clearfix"></div>
                </div>
                {/* {
                    guestDetail.map((y) => {
                        return (
                            <div className="guest-opt">
                                <div className="guest-opt-gry-bdr"></div>
                                <div className="top-guest-opt">
                                    <div>
                                        <div className="guest-opt-gry-bg"></div>
                                        <p>Guest {y?.BookingSer_No}</p>
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        )
                    })
                } */}
                <div className="guest-opt-content">
                    {" "}
                    Please fill up or verify your details below, upload your Photo ID
                    proofs and click Proceed{" "}
                </div>
                <form novalidate="" className="ng-untouched ng-pristine ng-invalid">
                    <div className="reg-form-bg">
                        <h4>Personal Details</h4>
                        <div className="reg-main-div">
                            <div className="row">
                                <div className="col-12">
                                    <InnTextbox
                                        id="guest-name"
                                        className="form-group"
                                        customError={validationObj.GuestName}
                                        value={guestName}
                                        onChange={(v) => {
                                            // console.log("selectedCountryCode", selectedCountryCode)
                                            setGuestName(v);
                                            setValidationObj((prev) => ({ ...prev, GuestName: "" }))
                                        }}
                                    >
                                        Name
                                    </InnTextbox>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-3">
                                    <div className="form-group">
                                        <InnSingleSelectDropdown
                                            id="c"
                                            title="Select"
                                            list={countryCodeCombo}
                                            customError={validationObj.CountryCode}
                                            //selectedSerNo={selectedCountryCode === undefined || selectedCountryCode == "" ? countryCodeCombo[0]?.key : selectedCountryCode}
                                            selectedSerNo={selectedCountryForISDCode === undefined || selectedCountryForISDCode == "" ? countryCodeCombo[0]?.key : selectedCountryForISDCode}
                                            name="Single Select"
                                            // label="HK Status"
                                            onChange={(item, name) => {
                                                setSelectedCountryCode(item?.value);
                                                setSelectedCountryForISDCode(item?.key)
                                                setValidationObj((prev) => ({ ...prev, CountryCode: "" }))

                                            }}
                                            searchable={["Search country code...", "No country found"]}

                                        ></InnSingleSelectDropdown>
                                    </div>
                                </div>
                                <div className="col-9 pl-0">
                                    <div className="form-group field" style={{ marginTop: 18, marginLeft: 30 }}>
                                        <InnTextbox
                                            className="form-group"
                                            value={guestMobileNo}
                                            onChange={(v) => {
                                                setGuestMobileNo(v);
                                            }}
                                        >
                                            Mobile
                                        </InnTextbox>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <InnTextbox
                                        className="form-group"
                                        value={guestEmail}
                                        onChange={(v) => {
                                            setGuestEmail(v);
                                        }}
                                    >
                                        Email ID
                                    </InnTextbox>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group dropdown-lbl">
                                        <InnSingleSelectDropdown
                                            id="c"
                                            title="Nationality"
                                            list={nationalityCombo}
                                            customError={validationObj.Nationality}
                                            selectedSerNo={selectedNationality === undefined || selectedNationality === null || selectedNationality == "" ? nationalityCombo[0]?.key : selectedNationality}
                                            name='Nationality'
                                            label="Nationality"
                                            onChange={(item, name) => {
                                                setSelectedNationality(item?.key)
                                                setSelectedCountryID(item.CountryID);
                                                setSelectedCountryForISDCode(item.CountryID);
                                                setSelectedCountryCode(countryCodeCombo.find(x => item.CountryID == x.CountryID).value)
                                                //console.log("countryCodeCombo.find(x => item.CountryID == x.CountryID).key", countryCodeCombo.find(x => item.CountryID == x.CountryID).value)
                                                setValidationObj((prev) => ({ ...prev, Nationality: "" }))
                                                // console.log(item)
                                                // console.log(countryCodeCombo.find(x => item.CountryID == x.CountryID))

                                            }}
                                            searchable={["Search nationality...", "No nationality found"]}
                                        ></InnSingleSelectDropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="reg-form-bg m-tp20">
                        <h5 style={{ paddingTop: 30 }}>Upload ID Proof</h5>
                        <div className="reg-main-div">
                            <ul>
                                <li>Upload image of both sides of the front page</li>
                                <li>Ensure the image is legible</li>
                            </ul>
                            {
                                selectedNationality == "INDIA" ?
                                    <div className="guest-detail">
                                        <div className="row">
                                            {/* {
                                        filterGuestDetail?.IDType === null || filterGuestDetail?.IDType === undefined ? */}
                                            <div className="col-8">
                                                <div className="form-group dropdown-lbl">
                                                    <InnSingleSelectDropdown
                                                        id="c"
                                                        title="ID Type"
                                                        list={idTypeCombo}
                                                        customError={validationObj.IDType}
                                                        selectedSerNo={selectedIDTypeCombo === undefined || selectedIDTypeCombo == "" ? idTypeCombo[0]?.key : selectedIDTypeCombo}
                                                        name="ID Type"
                                                        label="ID Type"
                                                        onChange={(item, name) => {
                                                            setSelectedIDTypeCombo(item.key);
                                                            setValidationObj((prev) => ({ ...prev, IDType: "" }))
                                                        }}
                                                    ></InnSingleSelectDropdown>
                                                </div>
                                            </div>
                                            {/* :
                                            <></> */}
                                            {/* } */}
                                            <div className="col-4">
                                                <div className="m-tp20">
                                                    <Link to="/PreviewExample">
                                                        <button className="reg-light-btn"> Example </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    null
                            }

                            <div className="guest-detail mt-3">
                                <div className="row">
                                    <div className="col-8">
                                        <div className="guest-detail bdr-rgt">
                                            {
                                                frontPageImage === undefined || frontPageImage === "" || frontPageImage == null ?
                                                    <div className="id-proof-not-grn-bg"></div>
                                                    :
                                                    frontPageImage?.fpath !== undefined || frontPageImage?.fpath === "" ?
                                                        <div className="id-proof-grn-bg"></div>
                                                        :
                                                        frontPageImage !== undefined || frontPageImage !== "" ?
                                                            <div className="id-proof-grn-bg"></div>
                                                            :
                                                            <div className="id-proof-not-grn-bg"></div>
                                            }
                                            <div className="id-preview-text pos-rel">
                                                <p>Front Page</p>
                                            </div>
                                            <div style={{ cursor: 'pointer', position: 'relative' }}>
                                                <InnLoader className={frontLoading ? "active" : null}></InnLoader>
                                                <InnFileUpload
                                                    customError={frontPageImage === undefined ? 'Please upload front page' : ""}
                                                    onChange={async (v) => {
                                                        try {
                                                            setFrontLoading(true);
                                                            let strName =
                                                                PropertyID +
                                                                (guestObj?.Booking_No === undefined
                                                                    ? guestDetailObj?.Booking_No
                                                                    : guestObj?.Booking_No) +
                                                                (guestObj?.BookingSer_No === undefined
                                                                    ? defaultSerNo?.BookingSer_No?.trim()
                                                                    : guestObj?.BookingSer_No?.trim()) +
                                                                (guestObj?.BookingSubSer_No === undefined
                                                                    ? defaultSerNo?.BookingSubSer_No?.trim()
                                                                    : guestObj?.BookingSubSer_No?.trim()) +
                                                                guestObj?.Ser_No;

                                                            const filePath = v.fpath;
                                                            let mimeType;
                                                            let filetype;
                                                            if (filePath?.includes("application/pdf")) {
                                                                mimeType = "application/pdf";
                                                                filetype = ".pdf";
                                                            } else if (filePath?.includes("image/png")) {
                                                                mimeType = "image/png";
                                                                filetype = ".png";
                                                            } else if (filePath?.includes("image/jpeg") || immigrationStamp?.includes("image/jpg")) {
                                                                mimeType = "image/jpeg";
                                                                filetype = ".jpeg";
                                                            }

                                                            let fileName = `${strName}${filetype}`;

                                                            const formattedDate = moment().format("YYYYMMDDHHmmssSSSS");
                                                            const path = `Img/${ClientID}/Guest_Images/SCA_Front_${formattedDate}_${fileName}`;

                                                            let InsertPath =`${ClientID}/Guest_Images/SCA_Front_${formattedDate}_${fileName}`;
                                                           
                                                            await ValidateMediaFunctionUpload(path, filePath, mimeType ,'Front',InsertPath);

                                                        } finally {
                                                            setFrontLoading(false);
                                                        }
                                                    }}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-4">
                                        {/* <Link to="/Preview"> */}
                                        <a className="id-preview-button" disabled={frontPageImage === undefined || frontPageImage === null ? true : false}
                                            style={{ pointerEvents: frontPageImage === undefined || frontPageImage === null ? "none" : "auto", opacity: frontPageImage === undefined || frontPageImage === null ? 0.5 : 1 }}
                                            onClick={() => {
                                                dispatch(clearAllData());
                                                // if (oldFrontPageImage) {
                                                let temp = {
                                                    fpath: frontPageImage
                                                }
                                                dispatch(setFrontPagePhoto(temp));
                                                if (temp.fpath.includes('image/')) {
                                                    dispatch(setDocumentType("image/"))
                                                } else if (temp.fpath.includes('application/pdf')) {
                                                    dispatch(setDocumentType("application/pdf"))
                                                } else {
                                                    console.log('Unknown type.');
                                                }

                                                setPreviewPopup(true)
                                                // navigate("/Preview")
                                                // }

                                                // else if (frontPageImage?.fpath) {
                                                //     dispatch(setFrontPagePhoto(frontPageImage));
                                                //     navigate("/Preview")
                                                // }
                                                // else if (frontPageImage !== undefined) {
                                                //     let temp = {
                                                //         fpath: frontPageImage
                                                //     }
                                                //     dispatch(setFrontPagePhoto(temp));
                                                //     navigate("/Preview")
                                                // }
                                                // else {
                                                //     alert("Please upload photo.")
                                                // }
                                            }}> Preview</a>
                                        {/* </Link> */}
                                    </div>
                                </div>
                            </div>
                            <div className="guest-detail m-tp20">
                                <div className="row">
                                    <div className="col-8">
                                        <div className="guest-detail bdr-rgt">
                                            {
                                                backPageIamge === undefined || backPageIamge === "" || backPageIamge == null ?
                                                    <div className="id-proof-not-grn-bg"></div>
                                                    :
                                                    backPageIamge?.fpath !== undefined || backPageIamge?.fpath === "" ?
                                                        <div className="id-proof-grn-bg"></div>
                                                        :
                                                        backPageIamge !== undefined || backPageIamge !== "" ?
                                                            <div className="id-proof-grn-bg"></div>
                                                            :
                                                            <div className="id-proof-not-grn-bg"></div>
                                            }
                                            <div className="id-preview-text pos-rel">
                                                <p>Back Page</p>
                                            </div>
                                            <div style={{ cursor: 'pointer', position: 'relative' }}>
                                                <InnLoader className={backLoading ? "active" : null}></InnLoader>
                                                <InnFileUpload
                                                    customError={backPageIamge === undefined ? 'Please upload back page' : ""}
                                                    onChange={async (v) => {
                                                        try {
                                                            setBackLoading(true);

                                                             let strName =
                                                                PropertyID +
                                                                (guestObj?.Booking_No === undefined
                                                                    ? guestDetailObj?.Booking_No
                                                                    : guestObj?.Booking_No) +
                                                                (guestObj?.BookingSer_No === undefined
                                                                    ? defaultSerNo?.BookingSer_No?.trim()
                                                                    : guestObj?.BookingSer_No?.trim()) +
                                                                (guestObj?.BookingSubSer_No === undefined
                                                                    ? defaultSerNo?.BookingSubSer_No?.trim()
                                                                    : guestObj?.BookingSubSer_No?.trim()) +
                                                                guestObj?.Ser_No;

                                                            const filePath = v.fpath;
                                                            let mimeType;
                                                            let filetype;
                                                            if (filePath?.includes("application/pdf")) {
                                                                mimeType = "application/pdf";
                                                                filetype = ".pdf";
                                                            } else if (filePath?.includes("image/png")) {
                                                                mimeType = "image/png";
                                                                filetype = ".png";
                                                            } else if (filePath?.includes("image/jpeg") || immigrationStamp?.includes("image/jpg")) {
                                                                mimeType = "image/jpeg";
                                                                filetype = ".jpeg";
                                                            }

                                                            let fileName = `${strName}${filetype}`;
                                                            const formattedDate = moment().format("YYYYMMDDHHmmssSSSS");
                                                            const path = `Img/${ClientID}/Guest_Images/SCA_Back_${formattedDate}_${fileName}`;

                                                            let InsertPath = `${ClientID}/Guest_Images/SCA_Back_${formattedDate}_${fileName}`;
                                                            await ValidateMediaFunctionUpload(path, filePath, mimeType, 'Back',InsertPath);

                                                        } finally {
                                                            setBackLoading(false);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        {/* <Link to="/Preview"> */}
                                        <a className="id-preview-button"
                                            disabled={backPageIamge === undefined || backPageIamge === null ? true : false}
                                            style={{ pointerEvents: backPageIamge === undefined || backPageIamge === null ? "none" : "auto", opacity: backPageIamge === undefined || backPageIamge === null ? 0.5 : 1 }}
                                            onClick={() => {
                                                dispatch(clearAllData());
                                                // if (oldBackPageImage) {
                                                let temp = {
                                                    fpath: backPageIamge
                                                }
                                                dispatch(setBackPagePhoto(temp));
                                                if (temp.fpath.includes('image/')) {
                                                    dispatch(setDocumentType("image/"))
                                                } else if (temp.fpath.includes('application/pdf')) {
                                                    dispatch(setDocumentType("application/pdf"))
                                                } else {
                                                    console.log('Unknown type.');
                                                }
                                                // navigate("/Preview")
                                                setPreviewPopup(true)
                                                // }
                                                // else if (backPageIamge !== "" || backPageIamge !== undefined) {
                                                //     let temp = {
                                                //         fpath: backPageIamge
                                                //     }
                                                //     dispatch(setBackPagePhoto(temp));
                                                //     // navigate("/Preview")
                                                //     setPreviewPopup(true)
                                                // }
                                                // else if (backPageIamge) {
                                                //     dispatch(setBackPagePhoto(backPageIamge));
                                                //     // navigate("/Preview")
                                                //     setPreviewPopup(true)
                                                // } else {
                                                //     alert("Please upload photo.")
                                                // }

                                            }}
                                        > Preview </a>
                                        {/* </Link> */}
                                    </div>
                                </div>
                            </div>
                            {
                                selectedNationality == "INDIA" ?
                                    null
                                    :
                                    <>
                                        <div className="guest-detail mt-3">
                                            <div className="row">
                                                <div className="col-8">
                                                    <div className="guest-detail bdr-rgt">
                                                        {
                                                            visaStamp === undefined || visaStamp === "" || visaStamp == null ?
                                                                <div className="id-proof-not-grn-bg"></div>
                                                                :
                                                                visaStamp?.fpath !== undefined || visaStamp?.fpath === "" ?
                                                                    <div className="id-proof-grn-bg"></div>
                                                                    :
                                                                    visaStamp !== undefined || visaStamp !== "" ?
                                                                        <div className="id-proof-grn-bg"></div>
                                                                        :
                                                                        <div className="id-proof-not-grn-bg"></div>
                                                        }
                                                        <div className="id-preview-text pos-rel">
                                                            <p>Visa Stamp Page</p>
                                                        </div>
                                                        <div style={{ cursor: 'pointer', position: 'relative' }}>
                                                            <InnLoader className={visaLoading ? "active" : null}></InnLoader>
                                                            <InnFileUpload
                                                                customError={visaStamp === undefined ? 'Please upload visa page' : ""}
                                                                onChange={async (v) => {
                                                                    try {
                                                                        setVisaLoading(true);

                                                                        let strName =
                                                                            PropertyID +
                                                                            (guestObj?.Booking_No === undefined
                                                                                ? guestDetailObj?.Booking_No
                                                                                : guestObj?.Booking_No) +
                                                                            (guestObj?.BookingSer_No === undefined
                                                                                ? defaultSerNo?.BookingSer_No?.trim()
                                                                                : guestObj?.BookingSer_No?.trim()) +
                                                                            (guestObj?.BookingSubSer_No === undefined
                                                                                ? defaultSerNo?.BookingSubSer_No?.trim()
                                                                                : guestObj?.BookingSubSer_No?.trim()) +
                                                                            guestObj?.Ser_No;

                                                                        const filePath = v.fpath;
                                                                        let mimeType;
                                                                        let filetype;
                                                                        if (filePath?.includes("application/pdf")) {
                                                                            mimeType = "application/pdf";
                                                                            filetype = ".pdf";
                                                                        } else if (filePath?.includes("image/png")) {
                                                                            mimeType = "image/png";
                                                                            filetype = ".png";
                                                                        } else if (filePath?.includes("image/jpeg") || immigrationStamp?.includes("image/jpg")) {
                                                                            mimeType = "image/jpeg";
                                                                            filetype = ".jpeg";
                                                                        }

                                                                        let fileName = `${strName}${filetype}`;
                                                                        const formattedDate = moment().format("YYYYMMDDHHmmssSSSS");
                                                                        const path = `Img/${ClientID}/Guest_Images/SCA_VISA_${formattedDate}_${fileName}`;
                                                        
                                                                        let InsertPath = `${ClientID}/Guest_Images/SCA_VISA_${formattedDate}_${fileName}`;
                                                                        await ValidateMediaFunctionUpload(path, filePath, mimeType, 'Visa',InsertPath);

                                                                    } finally {
                                                                        setVisaLoading(false);
                                                                    }
                                                                }}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    {/* <Link to="/Preview"> */}
                                                    <a className="id-preview-button" disabled={visaStamp === undefined || visaStamp === null ? true : false}
                                                        style={{ pointerEvents: visaStamp === undefined || visaStamp === null ? "none" : "auto", opacity: visaStamp === undefined || visaStamp === null ? 0.5 : 1 }}
                                                        onClick={() => {
                                                            dispatch(clearAllData());
                                                            // if (oldvisaStamp) {
                                                            let temp = {
                                                                fpath: visaStamp
                                                            }
                                                            dispatch(setVisaStampImage(temp));
                                                            if (temp.fpath.includes('image/')) {
                                                                dispatch(setDocumentType("image/"))
                                                            } else if (temp.fpath.includes('application/pdf')) {
                                                                dispatch(setDocumentType("application/pdf"))
                                                            } else {
                                                                console.log('Unknown type.');
                                                            }

                                                            setPreviewPopup(true)
                                                            // navigate("/Preview")
                                                            // }

                                                            // else if (frontPageImage?.fpath) {
                                                            //     dispatch(setFrontPagePhoto(frontPageImage));
                                                            //     navigate("/Preview")
                                                            // }
                                                            // else if (frontPageImage !== undefined) {
                                                            //     let temp = {
                                                            //         fpath: frontPageImage
                                                            //     }
                                                            //     dispatch(setFrontPagePhoto(temp));
                                                            //     navigate("/Preview")
                                                            // }
                                                            // else {
                                                            //     alert("Please upload photo.")
                                                            // }
                                                        }}> Preview</a>
                                                    {/* </Link> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="guest-detail mt-3">
                                            <div className="row">
                                                <div className="col-8">
                                                    <div className="guest-detail bdr-rgt">
                                                        {
                                                            immigrationStamp === undefined || immigrationStamp === "" || immigrationStamp == null ?
                                                                <div className="id-proof-not-grn-bg"></div>
                                                                :
                                                                immigrationStamp?.fpath !== undefined || immigrationStamp?.fpath === "" ?
                                                                    <div className="id-proof-grn-bg"></div>
                                                                    :
                                                                    immigrationStamp !== undefined || immigrationStamp !== "" ?
                                                                        <div className="id-proof-grn-bg"></div>
                                                                        :
                                                                        <div className="id-proof-not-grn-bg"></div>
                                                        }
                                                        <div className="id-preview-text pos-rel">
                                                            <p>Immigration Stamp Page</p>
                                                        </div>
                                                        <div style={{ cursor: 'pointer', position: 'relative' }}>
                                                            <InnLoader className={immigrationLoading ? "active" : null}></InnLoader>
                                                            <InnFileUpload
                                                                customError={immigrationStamp === undefined ? 'Please upload immigration page' : ""}
                                                                onChange={async (v) => {
                                                                    try {
                                                                        setImmigrationLoading(true);

                                                                        let strName =
                                                                            PropertyID +
                                                                            (guestObj?.Booking_No === undefined
                                                                                ? guestDetailObj?.Booking_No
                                                                                : guestObj?.Booking_No) +
                                                                            (guestObj?.BookingSer_No === undefined
                                                                                ? defaultSerNo?.BookingSer_No?.trim()
                                                                                : guestObj?.BookingSer_No?.trim()) +
                                                                            (guestObj?.BookingSubSer_No === undefined
                                                                                ? defaultSerNo?.BookingSubSer_No?.trim()
                                                                                : guestObj?.BookingSubSer_No?.trim()) +
                                                                            guestObj?.Ser_No;

                                                                        const filePath = v.fpath;
                                                                        let mimeType;
                                                                        let filetype;
                                                                        if (filePath?.includes("application/pdf")) {
                                                                            mimeType = "application/pdf";
                                                                            filetype = ".pdf";
                                                                        } else if (filePath?.includes("image/png")) {
                                                                            mimeType = "image/png";
                                                                            filetype = ".png";
                                                                        } else if (filePath?.includes("image/jpeg") || immigrationStamp?.includes("image/jpg")) {
                                                                            mimeType = "image/jpeg";
                                                                            filetype = ".jpeg";
                                                                        }

                                                                        let fileName = `${strName}${filetype}`;
                                                                        const formattedDate = moment().format("YYYYMMDDHHmmssSSSS");
                                                                        const path = `Img/${ClientID}/Guest_Images/SCA_Immigration_${formattedDate}_${fileName}`;
                                                        
                                                                        let InsertPath = `${ClientID}/Guest_Images/SCA_Immigration_${formattedDate}_${fileName}`;

                                                                        await ValidateMediaFunctionUpload(path, filePath, mimeType , 'Immigration',InsertPath);

                                                                    } finally {
                                                                        setImmigrationLoading(false);
                                                                    }
                                                                }}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    {/* <Link to="/Preview"> */}
                                                    <a className="id-preview-button" disabled={immigrationStamp === undefined || immigrationStamp === null ? true : false}
                                                        style={{ pointerEvents: immigrationStamp === undefined || immigrationStamp === null ? "none" : "auto", opacity: immigrationStamp === undefined || immigrationStamp === null ? 0.5 : 1 }}
                                                        onClick={() => {
                                                            dispatch(clearAllData());
                                                            // if (oldFrontPageImage) {
                                                            let temp = {
                                                                fpath: immigrationStamp
                                                            }
                                                            dispatch(setImmigrationImage(temp));
                                                            if (temp.fpath.includes('image/')) {
                                                                dispatch(setDocumentType("image/"))
                                                            } else if (temp.fpath.includes('application/pdf')) {
                                                                dispatch(setDocumentType("application/pdf"))
                                                            } else {
                                                                console.log('Unknown type.');
                                                            }

                                                            setPreviewPopup(true)
                                                            // navigate("/Preview")
                                                            // }

                                                            // else if (frontPageImage?.fpath) {
                                                            //     dispatch(setFrontPagePhoto(frontPageImage));
                                                            //     navigate("/Preview")
                                                            // }
                                                            // else if (frontPageImage !== undefined) {
                                                            //     let temp = {
                                                            //         fpath: frontPageImage
                                                            //     }
                                                            //     dispatch(setFrontPagePhoto(temp));
                                                            //     navigate("/Preview")
                                                            // }
                                                            // else {
                                                            //     alert("Please upload photo.")
                                                            // }
                                                        }}> Preview</a>
                                                    {/* </Link> */}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                    <div
                        className="reg-form-bg m-tp20"
                        style={{ paddingRight: 20, paddingLeft: 20 }}
                    >
                        <h5 style={{ paddingTop: 30 }}>Travel Details</h5>
                        <div className="row">
                            <div className="col-12">
                                <InnTextbox
                                    className="form-group"
                                    value={travelleFrom}
                                    // customError={travelleFrom === undefined || "" ? "Please fill valid information." : ''}
                                    onChange={(v) => {
                                        setSelectedTravelleFrom(v);
                                    }}
                                >
                                    Where are you coming from to {propertyDetailObj?.CityName} ? <sup>*</sup>
                                </InnTextbox>
                            </div>
                        </div>
                        <div className="self-declarition-group m-tp30">
                            <div className="row">
                                <div className="col-12">
                                    <p className="new-label">How are you travelling ?</p>
                                    <div className="r-btn-section">
                                        <InnRadioButton
                                            position="V"
                                            groupname="group1"
                                            data={rTravelData}
                                            value={travelFromVia === "Ai" ? rTravelData[0]?.value : travelFromVia === "Ra" ? rTravelData[1]?.value : travelFromVia === "Ro" ? rTravelData[2]?.value : travelFromVia}
                                            onSelectionChange={(value) => {
                                                setTravelFromVia(value);
                                            }}
                                        ></InnRadioButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <InnTextbox
                                    className="form-group"
                                    value={travellFromDetail}
                                    onChange={(v) => {
                                        setTravellFromDetail(v);
                                    }}
                                >
                                    Travel Details (Flight No etc.)
                                </InnTextbox>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <InnTextbox
                                    className="form-group"
                                    value={travellTo}
                                    // customError={travellTo === undefined || "" ? "Please fill valid information." : ''}
                                    onChange={(v) => {
                                        setTravellTo(v);
                                    }}
                                >
                                    Where will you going to from {propertyDetailObj?.CityName} ? <sup>*</sup>
                                </InnTextbox>
                            </div>
                        </div>
                        <div className="self-declarition-group mt-4">
                            <div className="row">
                                <div className="col-12">
                                    <p className="new-label">How are you travelling ?</p>
                                    <div className="r-btn-section">
                                        <InnRadioButton
                                            position="V"
                                            groupname="group2"
                                            data={rTravelData}
                                            value={travellToVia === "Ai" ? rTravelData[0].value : travellToVia === "Ra" ? rTravelData[1].value : travellToVia === "Ro" ? rTravelData[2].value : travellToVia}
                                            onSelectionChange={(value) => {
                                                setTravellToVia(value)
                                            }}
                                        ></InnRadioButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <InnTextbox
                                    className="form-group"
                                    value={travelToDetail}
                                    onChange={(v) => {
                                        setTravelToDetail(v);
                                    }}
                                >
                                    Travel Details (Flight No etc.)
                                </InnTextbox>
                            </div>
                        </div>
                    </div>
                    <div
                        className="reg-form-bg m-tp20"
                        style={{ paddingRight: 20, paddingLeft: 20 }}
                    >
                        <div className="row">
                            <div className="col-12">
                                <h5 style={{ paddingTop: 30 }}>Self Declaration Form</h5>
                                <p className="sub">
                                    (For entrants in the high security zone)
                                </p>
                                <div className="self-declarition-group pos-rel m-btm20">
                                    <p className="new-label">
                                        Have you travelled to a foreign country or to a notified
                                        area affected by COVID-19 during the last 15 days?
                                    </p>
                                    <div className="r-btn-section">
                                        <InnRadioButton
                                            position="V"
                                            groupname="group3"
                                            data={rData}
                                            value={isTravelledOutside}
                                            onSelectionChange={(value) => {
                                                setIsTravelledOutside(value);
                                                setValidationObj((prev) => ({ ...prev, IsSelectedTravelledOutside: "" }));
                                            }}
                                        ></InnRadioButton>
                                    </div>
                                    {
                                        !isTravelledOutside &&
                                        <div className="error">
                                            <span>{validationObj.IsSelectedTravelledOutside}</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        {/* If radio  btn select Yes start */}
                        {
                            isTravelledOutside === "Yes" ?
                                <div className="covid_yes">
                                    <div className="row">
                                        <div className="col-6 pl-0">
                                            <div className="form-group dropdown-lbl">
                                                <InnSingleSelectDropdown
                                                    id="c"
                                                    title="Country"
                                                    list={countryCombo}
                                                    selectedSerNo={selectedCountry === '' ? countryCombo[0]?.key : selectedCountry}
                                                    name="Country"
                                                    label="Country"
                                                    onChange={(item, name) => {
                                                        setSelectedCountry(item.key)
                                                        setSelectedCountryforCity({ "key": item.key, "value": item.value })
                                                        setValidationObj((prev) => ({ ...prev, Country: "" }));
                                                    }}
                                                    searchable={["Search country...", "No country found"]}
                                                ></InnSingleSelectDropdown>
                                            </div>
                                            {
                                                !selectedCountry &&
                                                <div className="error">
                                                    <span>{validationObj.Country}</span>
                                                </div>
                                            }
                                        </div>
                                        <div className="col-6 pr-0">
                                            <div className="form-group dropdown-lbl">
                                                <InnSingleSelectDropdown
                                                    id="c"
                                                    title="City"
                                                    list={cityList}
                                                    selectedSerNo={filterGuestDetail?.TravelledCity === 0 || 1 ? cityList[0]?.key : selectedCountry}
                                                    // disabled={selectedCountry === undefined || '' ? true : false}
                                                    name="City"
                                                    label="City"
                                                    onChange={(item, name) => {
                                                        if (item.key !== undefined || item.key !== "") {
                                                            setSelectedCity("Yes");
                                                        } else {
                                                            setSelectedCity("No");
                                                        }
                                                        setValidationObj((prev) => ({ ...prev, City: "" }));
                                                    }}
                                                    searchable={["Search city...", "No city found"]}
                                                ></InnSingleSelectDropdown>
                                            </div>
                                            {
                                                !selectedCity &&
                                                <div className="error">
                                                    <span>{validationObj.City}</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 pl-0 pr-0">
                                            <div className="form-group field">
                                                <InnTextbox
                                                    className="form-group"
                                                    value={travelledArea}
                                                    customError={validationObj.Area}
                                                    onChange={(v) => {
                                                        setTravelledArea(v);
                                                        setValidationObj((prev) => ({ ...prev, Area: "" }));
                                                        // console.log(v)
                                                    }}
                                                >
                                                    Area <sup>*</sup>
                                                </InnTextbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <></>
                        }

                        {/* If radio btn select Yes end  */}


                        <div className="row">
                            <div className="col-12">
                                <div className="self-declarition-group m-btm20 pos-rel">
                                    <p className="new-label">
                                        Are you suffering from fever, cough and cold or similar
                                        symptoms?
                                    </p>

                                    <div className="r-btn-section">
                                        <InnRadioButton
                                            position="V"
                                            groupname="group4"
                                            data={rData}
                                            value={selectedCovid}
                                            onSelectionChange={(value) => {
                                                setSelectedCovid(value);
                                                setValidationObj((prev) => ({ ...prev, IsSelectedCovidOptn: "" }));
                                            }}
                                        ></InnRadioButton>
                                    </div>
                                    {
                                        !selectedCovid &&
                                        <div className="error">
                                            <span>{validationObj.IsSelectedCovidOptn}</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div className="self-declarition-group pos-rel m-btm20">
                                    <p className="new-label">
                                        Has any of your family member or person(s) whom you have met
                                        recently displayed aforesaid symptoms recently?
                                    </p>
                                    <div className="r-btn-section">
                                        <InnRadioButton
                                            position="V"
                                            groupname="group5"
                                            data={rData}
                                            value={isFamilyHasSymptoms}
                                            onSelectionChange={(value) => {
                                                setIsFamilyHasSymptoms(value);
                                                setValidationObj((prev) => ({ ...prev, IsSelectedFamilySymptomsOptn: "" }));
                                            }}
                                        ></InnRadioButton>
                                    </div>
                                    {
                                        !isFamilyHasSymptoms &&
                                        <div class="error">
                                            <span>{validationObj.IsSelectedFamilySymptomsOptn}</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <Link to="/Registration1">
                        <div className="reg-detail m-tp10 m-btm20">
                            <button type="button" className="drk-blue-btn" onClick={onClickProceedButton()}>
                                {" "}
                                Proceed{" "}
                            </button>
                        </div>
                    </Link> */}
                    {
                        <div className="reg-detail m-tp10 m-btm20" key={filterGuestDetail?.BookingSer_No}>
                            <button type="button" className="drk-blue-btn" onClick={() => {
                                validate()
                                // if (guestDetail.length !== 0) {
                                //     for (let index = 0; index < guestDetail.length; index++) {
                                // index++
                                onClickProceedButton();
                                //     }
                                // } else {
                                //     onClickProceedButton(1);
                                // }
                            }}>
                                {" "}
                                Proceed{" "}
                            </button>
                        </div>
                    }
                </form>
            </div>

            <div className="overlay">
                <div className="overlay-background"></div>
                {/* <div className="overlay-content"><span className="spinner"></span>&nbsp;&nbsp;&nbsp;Loading
                </div> */}
            </div>
            <div className="hidden">
                <div className="loader-overlay"></div>
            </div>

            {showCalenderData ? (
                <InnModalPopup Onclose={() => setShowCalenderData(false)}>
                    <div className="modal-content x-small-popup">
                        <div
                            id="myModal3"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="myModalLabel3"
                            className="model-popup"
                        >
                            <div role="document">
                                <div className="reg-detail text-left">
                                    <h2>{filterGuestDetail?.GuestName}</h2>
                                </div>
                                <div className="reg-detail p-btm30">
                                    <div className="wdth50 bdr-rgt">
                                        <p>{moment(new Date(guestDetailObj?.Arrival_Date)).format("DD MMM")} - {moment(new Date(guestDetailObj?.Departure_Date)).format("DD MMM")}</p>
                                        <p>{guestDetailObj?.No_Of_Nights} Nights</p>
                                    </div>
                                    <div className="wdth50">
                                        <p className="text-right">Booking No: {guestDetailObj?.Booking_No}</p>
                                        <p className="text-right">{guestDetailObj?.No_Of_Rooms} Room {guestDetailObj?.Adult} Adults</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </InnModalPopup>
            ) : null}
            {
                previewPopup ?
                    <InnModalPopup Onclose={() => setPreviewPopup(false)}>
                        <Preview />
                    </InnModalPopup>
                    :
                    null
            }

        </div>
    );
}

export default Registration;
